import React, { FC } from 'react';

import { ImgShadow } from '@components/ImgShadow';
import type { IAirdropBox } from '@type/airdrop';
import { airdropReceiveStatus } from '@widget/airdrop/constants';
import { Lottie } from '@widget/airdrop/Lottie';

import styles from './index.module.less';
interface linkProps {
  cover: IAirdropBox;
  status: number;
  lottieShow: boolean;
  onFinish: () => void;
  className?: string
}
const dropCover = {
  FLOWER: {
    url: require('@images/airdrop/rose.webp'),
    width: 85,
    height: 188
  },
  CAR: {
    url: require('@images/airdrop/car.webp'),
    width: 236,
    height: 116
  },
  TOILET: {
    url: require('@images/airdrop/toilet.webp'),
    width: 135,
    height: 179
  },
  ROCKET: {
    url: require('@images/airdrop/rocket.webp'),
    width: 110,
    height: 164
  },
  QUESTION: {
    url: require('@images/airdrop/question.webp'),
    width: 148,
    height: 127
  }
};
export const LottieCover: FC<linkProps> = (props) => {
  const { lottieShow, cover, status, onFinish } = props;
  const coverStr = status === airdropReceiveStatus.noActive ? 'QUESTION' : cover;
  const onclose = () => {
    onFinish();
  }
  return (
    <>
       {lottieShow ? <Lottie name={cover} loop={false} className={styles.lottie} onFinish={onclose} />
         : <ImgShadow
        width={dropCover[coverStr]?.width}
        height={dropCover[coverStr]?.height}
        src={dropCover[coverStr]?.url}
        className={styles.img} />
        }
    </>
  );
};
